module.exports = __webpack_public_path__ + "assets/img/title@2x.ff776aff.png";